/**
 * Stage 2e: Internal Link Discovery — context-based version using StagePanel.
 *
 * Searches Talaera's site for pages that could be linked from this article.
 * Non-LLM stage (Tavily search). Link editing goes through the document editor.
 */

import React from 'react';
import { StagePanel } from '../StagePanel';
import { useArticleContext } from '../ArticleContext';
import type { ArticleDocument } from '../types';

function InputSummary() {
  const { document } = useArticleContext();
  const primary = document?.targeting?.keywords?.primary;
  return (
    <div className="text-xs text-gray-600 bg-gray-50 rounded border p-2">
      <span className="text-gray-400">Primary keyword:</span>{' '}
      {primary?.keyword || 'Not yet selected'}
    </div>
  );
}

function renderOutput(doc: ArticleDocument) {
  const links = doc.content_research?.internal_link_candidates;
  if (!links || links.length === 0) {
    return <div className="text-sm text-gray-500">No internal link candidates yet.</div>;
  }
  return (
    <div>
      <div className="text-xs font-medium text-gray-700 mb-1">
        Internal link candidates ({links.length})
      </div>
      <div className="space-y-1">
        {links.map((link, i) => (
          <div key={i} className="text-xs border rounded px-2 py-1 border-gray-200">
            <div className="font-medium text-gray-800">{link.target_page}</div>
            <div className="text-blue-500">{link.url}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function Stage2eInternalLinksV2() {
  const { document } = useArticleContext();
  const hasPrimary = Boolean(document?.targeting?.keywords?.primary);

  return (
    <StagePanel
      stageId="stage_2e_internal_links"
      title="Stage 2e: Internal Link Discovery"
      description="Searches talaera.com for pages to link from this article."
      runDisabled={!hasPrimary}
      runDisabledReason={!hasPrimary ? 'Requires a primary keyword (Stage 1b)' : undefined}
      renderOutput={renderOutput}
    >
      <InputSummary />
    </StagePanel>
  );
}
